var map = {
	"./Upanishad Publicity Still 1.jpg": 5083,
	"./Upanishad Publicity Still 2.jpg": 2284,
	"./Upanishad Publicity Still 3.jpg": 6425,
	"./Upanishad Publicity Still 4.jpg": 586,
	"./Upanishad Publicity Still 5.jpg": 8871
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1956;